const Table1 = ({ details }) => {
  return (
    <table
      className="approved assigned"
      style={{ marginTop: "15px", marginBottom: "15px" }}
    >
      <thead>
        <tr>
          <th className="center" style={{ width: "35%" }}>
            Organization
          </th>
          <th className="center" style={{ width: "41%" }}>
            Occupant
          </th>
          <th className="center" style={{ width: "24%" }}>
            Hotel
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="center">{details.organization}</td>
          <td className="center">{details.occupant}</td>
          <td className="center">{details.hotel}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default Table1;
